/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.document-card[_ngcontent-%COMP%] {\n  background-color: #f9f9f9;\n  transition: box-shadow 0.2s ease;\n  margin-bottom: 6px; }\n\n.document-card[_ngcontent-%COMP%]:hover {\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1); }\n\n.document-name[_ngcontent-%COMP%] {\n  font-weight: 500;\n  color: #333; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvbWVkaWNhbC1jYXNlcy91cGxvYWQtZG9jdW1lbnRzL3VwbG9hZC1kb2N1bWVudHMuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvbWVkaWNhbC1jYXNlcy91cGxvYWQtZG9jdW1lbnRzL3VwbG9hZC1kb2N1bWVudHMuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/medical-cases/upload-documents/upload-documents.component.scss.shim.ngstyle.ts